import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { ReviewTranslationStateModel } from 'models/common/review-types';

export const ReviewTranslationText: React.FunctionComponent<ReviewTranslationStateModel> = props => {
  const { reviewTranslationState } = props;

  let translationText = <LocalizedText message="hotels.infosite.reviews.translate.default.text" />;
  if (reviewTranslationState === 'loading') {
    translationText = <LocalizedText message="hotels.infosite.reviews.translate.loading.text" />;
  } else if (reviewTranslationState === 'translated') {
    translationText = <LocalizedText message="hotels.infosite.reviews.translate.show.original.text" />;
  }

  return translationText;
};
